// extracted by mini-css-extract-plugin
module.exports = {"root":"DragIcon_root__2yO5M"};